<template>
  <div class="payslip-label-value-table-scroll">
    <table class="payslip-label-value-table">
      <colgroup>
        <col class="payslip-label-value-table__col-label" />
        <col class="payslip-label-value-table__col-value" />
      </colgroup>
      <tbody>
        <tr v-for="(row, index) in rows" :key="rowKey(row, index)">
          <th scope="row" class="payslip-label-value-table__label">
            <span class="payslip-label-value-table__label-inner">
              <span class="payslip-label-value-table__label-text">
                {{ row.label }}
              </span>
              <button
                v-if="row.hint"
                type="button"
                class="payslip-label-value-table__help"
                :title="row.hint"
                :aria-label="`${row.label}: ${row.hint}`"
              >
                ?
              </button>
            </span>
          </th>
          <td
            class="payslip-label-value-table__value"
            :class="{
              'payslip-label-value-table__value--capitalize': row.capitalize,
            }"
          >
            {{ displayValue(row.value) }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'PayslipLabelValueTable',
  props: {
    rows: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    rowKey(row, index) {
      return row.key ?? row.label ?? `row-${index}`;
    },
    displayValue(value) {
      if (value === null || value === undefined || value === '') {
        return '—';
      }
      return String(value);
    },
  },
};
</script>

<style lang="scss" scoped>
.payslip-label-value-table-scroll {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  border: 1px solid $oxd-interface-gray-lighten-2-color;
  border-radius: 4px;
  overflow: hidden;
  box-sizing: border-box;
}

.payslip-label-value-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  background-color: $oxd-white-color;
  font-family: sans-serif;
  font-size: 12px;
  color: $oxd-interface-gray-darken-1-color;

  th,
  td {
    padding: 0.65rem 0.75rem;
    border-top: 1px solid $oxd-interface-gray-lighten-2-color;
    vertical-align: top;
    text-align: left;
    word-break: break-word;
  }

  tbody tr:first-child th,
  tbody tr:first-child td {
    border-top: 0;
  }

  &__label {
    font-weight: 600;
    color: $oxd-interface-gray-darken-2-color;
    background-color: $oxd-background-light-gray-color;
  }

  &__label-inner {
    display: inline-flex;
    align-items: center;
    gap: 0.35rem;
  }

  &__help {
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 1rem;
    height: 1rem;
    padding: 0;
    border: 1px solid $oxd-interface-gray-lighten-1-color;
    border-radius: 50%;
    background-color: $oxd-white-color;
    color: $oxd-primary-one-color;
    font-size: 0.7rem;
    font-weight: 700;
    line-height: 1;
    cursor: help;
    vertical-align: middle;

    &:hover,
    &:focus-visible {
      background-color: $oxd-primary-one-color;
      color: $oxd-white-color;
      outline: none;
    }
  }

  &__value {
    font-weight: 400;

    &--capitalize {
      text-transform: capitalize;
    }
  }

  &__col-label {
    width: 24%;
  }

  &__col-value {
    width: 76%;
  }
}
</style>
